import {Component, OnDestroy, OnInit} from '@angular/core';
import {MenuService} from "../../services/menu-service";
import {SecurityService} from "../../services/security.service";
import {Subscription} from "rxjs/internal/Subscription";

@Component({
    selector: 'app-loading-page',
    templateUrl: './loading-page.component.html',
    styleUrls: ['./loading-page.component.css'],
    standalone: false
})
export class LoadingPageComponent implements OnInit, OnDestroy {

  private loadingSub: Subscription | undefined;
  protected loadingInProgressScreen: boolean = false;

  constructor(private menuService: MenuService,
              private securityService: SecurityService) {
  }

  ngOnInit() {
    this.loadingSub = this.menuService.loadingStatusChanged.subscribe((status: boolean) => {
      this.loadingInProgressScreen = status;
      if (status) {
        // dal momento che e' diventato vero, mostro la pagina che e' condizionata dal loadingInProgressScreen
        // console.log('LoadingPageComponent: visualizzazione della pagina attivata');
      } else {
        // la visualizzazione dello splash screen e' gestita direttamente nel componente LoadingPageComponent
        // console.log('LoadingPageComponent: visualizzazione della pagina disattivata');
      }
    });
  }

  ngOnDestroy() {
    if (this.loadingSub) {
      this.loadingSub.unsubscribe();
    }
  }

}
